import 'core-js';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
// import 'core-js/es/symbol';
// import 'core-js/es/string';
// import 'core-js/es/string/repeat';
// import 'core-js/es/string/includes';
// import 'core-js/es/object';
// import 'core-js/web/dom-collections';
// import 'core-js/stable/dom-collections/iterator';
// import 'core-js/stable/dom-collections/for-each';
import 'proxy-polyfill';
import 'whatwg-fetch';

import React from 'react';
import 'mobx-react-lite/batchingForReactDom';
import ReactDOM from 'react-dom';
import './css/index.css';
import 'react-tooltip/dist/react-tooltip.css';
import App from './App';

if (window.location.hostname !== 'localhost') {
  const pageProtocol = window.location.protocol.toLowerCase();
  if (pageProtocol === 'http:') {
    window.location.href = window.location.href
      .toLowerCase()
      .replace('http:', 'https:');
  }
}

ReactDOM.render(<App />, document.getElementById('root'));
